import DigitalSolutions from "../About/DigitalSolutions";
import WhatWeDo from "../About/WhatWeDo";
import ProcessBox from "../sections/ProcessBox";
import { getSectionLayoutType } from "../../utils/sectionHelpers";
import SolutionsSection from "../sections/SolutionsSection";
import ServicesSection from "../sections/ServicesSection";
import WeServe from "../sections/WeServe";
import Industries from "../sections/Industries";
import HowItWorks from "../sections/HowItWorks";

const StrategyRenderer = ({ data }) => {
  const layoutType = getSectionLayoutType(data?.Settings);
  switch (layoutType) {
    case "slider":
      return <WhatWeDo data={data} />;

    case "tabs":
      return <DigitalSolutions data={data} />;

    case "process":
      return <ProcessBox data={data} />;

    case "services":
      return <SolutionsSection data={data} />;

    case "solutions":
      return <ServicesSection data={data} />;

    case "industries":
      return <WeServe data={data} />;

    case "framework":
      return <Industries data={data} />;

     case "cards":
      return <HowItWorks data={data} />;

    default:
      return null;
  }
};

export default StrategyRenderer;
